var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7106 14.8718C9.90293 15.016 10.1268 15.1125 10.3637 15.1533C10.6007 15.1941 10.8439 15.1779 11.0734 15.1062C11.3029 15.0346 11.5121 14.9094 11.6837 14.741C11.8553 14.5726 11.9844 14.3658 12.0604 14.1378C12.1365 13.9097 12.1572 13.6668 12.1209 13.4291C12.0847 13.1914 11.9925 12.9658 11.8519 12.7708C11.7113 12.5757 11.5264 12.4169 11.3124 12.3073C11.0984 12.1978 10.8614 12.1406 10.621 12.1406H1.51709",
    stroke: "white",
    strokeWidth: 1.51732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2763 6.07116C13.4703 5.81252 13.7271 5.60776 14.0225 5.47632C14.3179 5.34489 14.6419 5.29113 14.9639 5.32016C15.2859 5.3492 15.5951 5.46006 15.8622 5.64221C16.1293 5.82437 16.3454 6.07178 16.49 6.36094C16.6346 6.6501 16.7029 6.97143 16.6883 7.2944C16.6738 7.61737 16.577 7.93126 16.407 8.20627C16.237 8.48128 15.9996 8.70828 15.7172 8.86572C15.4348 9.02315 15.1169 9.10579 14.7936 9.10579H1.51709",
    stroke: "white",
    strokeWidth: 1.51732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43462 3.33862C7.62696 3.19437 7.85082 3.09788 8.08776 3.05712C8.32471 3.01636 8.56794 3.03249 8.79743 3.10417C9.02691 3.17586 9.23608 3.30105 9.40769 3.46944C9.5793 3.63782 9.70844 3.84457 9.78446 4.07266C9.86049 4.30074 9.88123 4.54362 9.84497 4.7813C9.80872 5.01897 9.7165 5.24462 9.57592 5.43966C9.43535 5.6347 9.25043 5.79355 9.03642 5.9031C8.82241 6.01266 8.58543 6.06979 8.34501 6.06979H1.51709",
    stroke: "white",
    strokeWidth: 1.51732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindWhite);
export default __webpack_public_path__ + "static/media/wind-white.56e504b3138835223188b832ff9e7035.svg";
export { ForwardRef as ReactComponent };